import { Analytics } from '@billx/analytics';
import { useCurrentUser } from '@billx/api';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import { ErrorBoundary, SentryErrorBoundary } from '@/components/common';
import { initSentry } from '@/lib/sentry';
import {
  NotificationProvider,
  QueryProvider,
  UserAuthProvider,
} from '@/providers';
import { createAppTheme, DEFAULT_APP_THEME } from '@/themes';

import { AppRoutes } from './routes';

const AppContent: React.FC = () => {
  const { currentUser } = useCurrentUser();

  return (
    <ThemeProvider
      theme={createAppTheme(
        currentUser?.preferences?.theme ?? DEFAULT_APP_THEME
      )}
    >
      <CssBaseline />
      <Router>
        <AppRoutes />
      </Router>
    </ThemeProvider>
  );
};

const App: React.FC = () => {
  // Initialize Sentry and Analytics
  useEffect(() => {
    if (!import.meta.env.DEV) {
      initSentry();
    }
    Analytics.initialize();
  }, []);

  return (
    <SentryErrorBoundary>
      <NotificationProvider>
        <ErrorBoundary>
          <QueryProvider>
            <UserAuthProvider>
              <AppContent />
            </UserAuthProvider>
          </QueryProvider>
        </ErrorBoundary>
      </NotificationProvider>
    </SentryErrorBoundary>
  );
};

export default App;
